"use client";

import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getStorage, type FirebaseStorage } from "firebase/storage";

// Only initialize Firebase if NOT using local auth (same gate as src/lib/firebase.ts)
const USE_LOCAL_AUTH = process.env.NEXT_PUBLIC_USE_LOCAL_AUTH === 'true';

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

let firebaseClientApp: FirebaseApp = null as unknown as FirebaseApp;
let firebaseClientAuth: Auth = null as unknown as Auth;
let firebaseClientStorage: FirebaseStorage = null as unknown as FirebaseStorage;

if (!USE_LOCAL_AUTH && firebaseConfig.apiKey) {
    try {
        firebaseClientApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        firebaseClientAuth = getAuth(firebaseClientApp);
        firebaseClientStorage = getStorage(firebaseClientApp);
    } catch (e) {
        console.warn("Firebase client init failed", e);
    }
}

let _db: Firestore | null = null;
function getFirestoreDb(): Firestore | null {
    if (USE_LOCAL_AUTH) {
        return null;
    }
    if (!_db) {
        _db = getFirestore(firebaseClientApp);
    }
    return _db;
}

let _storage: FirebaseStorage | null = null;
function getStorageDb(): FirebaseStorage | null {
    if (USE_LOCAL_AUTH) {
        return null;
    }
    if (!_storage) {
        _storage = getStorage(firebaseClientApp);
    }
    return _storage;
}

export {
    firebaseClientApp,
    firebaseClientAuth,
    firebaseClientStorage,
    getFirestoreDb,
    getStorageDb
};
